/** @format */
import { MarketSlug } from '@mpb-com/feather/enums';

import { IDP_LOCALES, IDP_LOCALE_BY_MARKET_SLUG, IdpLocale } from './constants';

export const getIdpLocale = (marketSlug?: string): IdpLocale | undefined =>
    marketSlug
        ? IDP_LOCALE_BY_MARKET_SLUG[marketSlug as MarketSlug]
        : undefined;

export const isIdpLocale = (value?: string): value is IdpLocale =>
    // eslint-disable-next-line @typescript-eslint/array-type -- Legacy code: do not use as an example.
    (IDP_LOCALES as readonly string[]).includes(value ?? '');

export const buildIdpForgottenPasswordUrl = (locale?: string): string =>
    `${process.env.PUBLIC_IDP_URL ?? ''}${
        locale ? `/${locale}` : ''
    }/forgotten-password`;
